@if (dataIsLoaded) {
  <section class="page-not-found__error">
    <h1 [innerHTML]="data.page_title"></h1>
  </section>
}
